const DEFAULT_ERROR_MESSAGE = "Щось пішло не так. Спробуйте ще раз.";

/**
 * Extracts a human-readable message from a failed axios request, regardless
 * of which of the backend's JSON error shapes it used:
 * - `{ message: string }`
 * - `{ error: string }`
 * - `{ errors: string[] }` (Rails `record.errors.full_messages`)
 * - `{ errors: [{ title: string }] }` (JSON:API-style, guest booking API)
 * - `{ field: string[], ... }` (raw ActiveModel errors hash)
 */
export function extractErrorMessage(error: any, fallback?: string): string {
  const data = error?.response?.data;

  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message) {
      return data.message;
    }

    if (typeof data.error === "string" && data.error) {
      return data.error;
    }

    if (Array.isArray(data.errors) && data.errors.length) {
      const [first] = data.errors;

      if (typeof first === "string") {
        return data.errors.filter((item: unknown) => typeof item === "string").join(", ");
      }

      if (first && typeof first === "object" && typeof first.title === "string") {
        return first.title;
      }
    }

    if (!Array.isArray(data)) {
      const messages = Object.values(data)
        .flat()
        .filter((value): value is string => typeof value === "string");

      if (messages.length) {
        return messages.join(", ");
      }
    }
  }

  return error?.message || fallback || DEFAULT_ERROR_MESSAGE;
}
